// Port of api/fuel/app/classes/controller/api/monty/session/check.php
import Constants from 'offline/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import Buddies from 'offline/model/buddies'
import Config from 'offline/model/config'
import Game from 'offline/model/game'
import Group from 'offline/model/group'
import Notification from 'offline/model/notification'
import User from 'offline/model/user'

function sessionUser(userId) {
	if (!userId) return null
	return User.with_id(userId)
}

function earlyAccessSlugs(userId) {
	if (!userId) return []

	var rows = DB.query('SELECT early_slug, early_adopted FROM platform_early')
	var access = []

	for (var i = 0; i < rows.length; i++) {
		var adopted = rows[i].early_adopted || []
		if (typeof adopted === 'string') {
			try { adopted = JSON.parse(adopted) } catch (e) { adopted = [] }
		}
		if (!Array.isArray(adopted)) adopted = []
		if (adopted.indexOf(String(userId)) !== -1 || adopted.indexOf(parseInt(userId, 10)) !== -1) {
			access.push(rows[i].early_slug)
		}
	}

	return access
}

function sessionUserArray(user) {
	if (!user) return false

	var data = user.to_array()
	data.nextSync = parseInt(user.get_date_next_sync() || 0, 10)
	data.date.upgraded = parseInt(user.get_date_upgrade() || 0, 10)
	data.upgraded = parseInt(user.get_upgrade() || 0, 10)
	data.countdown = !!user.get_upgrade()
	data.perks = user.get_perks() || {}
	data.early = earlyAccessSlugs(user.get_id())

	return data
}

function presetArray(row) {
	return {
		id: parseInt(row.preset_id, 10),
		type: parseInt(row.preset_type, 10),
		name: row.preset_name,
		filter: row.preset_filter || {},
		default: parseInt(row.preset_default || 0, 10)
	}
}

function notificationArray(row) {
	var notification = Notification.forge(row)
	return {
		id: parseInt(row.notification_id, 10),
		date: parseInt(row.notification_date, 10),
		type: parseInt(row.notification_type, 10),
		title: row.notification_title,
		content: row.notification_content,
		data: notification.get_data() || {},
		link: row.notification_link,
		image: row.notification_image,
		prompt: parseInt(row.notification_prompt || 0, 10)
	}
}

export default function(params) {
	var currentTime = Util.time()
	var user = sessionUser(params.sessionUserId || DB.meta('sync_user_id'))
	var groups = false
	var recent = false
	var presets = false
	var config = Config.user(user ? user.get_id() : false)
	var notification = false
	var notifications = 0
	var data = {
		games: []
	}

	if (user) {
		groups = []
		recent = []

		if (user.get_count_buddies()) {
			var buddies = DB.query('SELECT * FROM buddies WHERE user_id = ? LIMIT 1', [user.get_id()])
			if (buddies.length) {
				var buddiesData = Buddies.forge(buddies[0]).to_array()
				buddiesData.name = 'GeekBuddies'
				buddiesData.type = 'buddies'
				groups.push(buddiesData)
			}
		}

		var groupRows = DB.query(
			'SELECT g.* FROM link_group_user l JOIN groups g ON g.group_id = l.group_id WHERE l.user_id = ? AND g.group_type = ? ORDER BY g.group_name ASC',
			[user.get_id(), 1]
		)

		for (var gi = 0; gi < groupRows.length; gi++) {
			var group = Group.forge(groupRows[gi]).to_array()
			group.type = 'groups'
			groups.push(group)
		}

		presets = DB.query(
			'SELECT * FROM preset WHERE user_id = ? ORDER BY preset_name ASC',
			[user.get_id()]
		).map(presetArray)

		if (config && config.lists && config.lists.unplayed && config.lists.unplayed.games && config.lists.unplayed.games.length) {
			Game.where([
				['game_id', 'in', config.lists.unplayed.games]
			]).forEach(function(game) {
				data.games.push(game.to_array())
			})
		}

		var promptNotifications = DB.query(
			'SELECT * FROM notification WHERE notification_date > ? AND notification_date <= ? AND notification_prompt = 1 AND user_id IN (0, ?) ORDER BY notification_date DESC LIMIT 1',
			[currentTime - (Constants.TIME_DAY * 3), currentTime, user.get_id()]
		)

		if (promptNotifications.length) {
			notification = notificationArray(promptNotifications[0])
		}

		notifications = DB.scalar(
			'SELECT COUNT(*) FROM notification WHERE notification_date > ? AND notification_date <= ? AND user_id IN (0, ?)',
			[user.get_date_notifications() || 0, currentTime, user.get_id()]
		) || 0
	} else {
		var guestPromptNotifications = DB.query(
			'SELECT * FROM notification WHERE notification_date > ? AND notification_date <= ? AND notification_prompt = 1 AND user_id = 0 ORDER BY notification_date DESC LIMIT 1',
			[currentTime - (Constants.TIME_DAY * 3), currentTime]
		)

		if (guestPromptNotifications.length) {
			notification = notificationArray(guestPromptNotifications[0])
		}
	}

	return Promise.resolve({
		session: { offline: true },
		notifications: notifications,
		notification: notification,
		user: sessionUserArray(user),
		groups: groups,
		recent: recent,
		presets: presets,
		config: config,
		data: data
	})
}
